// IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T1)
// Регистр режимов вида ячеек отчёта REPORT2 (§1.4–1.6 плана p149): { key → { key, title, satellites, needsData, layersOf, tipOf, cacheKey? } }.
// Режимы: numbers (Числа — круга нет), composition (Склад, T3), status_zones (Статуси й зони; алиас прежнего status_pie), stock_impact, delta_prev_run,
// delta_30d (T9); status_dot (Статуси: крапка — st_val, круг постоянного диаметра), plans (Плани: виконання — plan_val) — T12. Контракт режима:
//   IE 2026 11 01 / ODOO-350449 (заказ Игоря: статуси-крапка, зони запасів, виконання планів — T12): layersOf может вернуть fixedDiameter — круг постоянного диаметра без шкалы (cellRing_build opts.fixedDiameter; грид передаёт res.fixedDiameter).
//   layersOf(dataItem, binding, ctx) → { layers: [{ key, title, value, color, tone }], value?, signals?, satellite? } | null — слои круга ячейки-даты;
//     ctx: { t, binding, date, measure, cell (= dataItem[date] — объект спутников), value (значение ячейки), row?, childrenOf?(dataItem) } (заполняет грид);
//   tipOf(res, ctx) → { caption?, rows?: [{ title, value, color, share? }], note?: [строки] } | null — Alt-подсказка (по умолчанию строки = слои);
//   needsData — нужен спутник бэка (satellites); нет в ячейке — режим ждёт отложенных данных (T2: cellView_dataReady / requestNow);
//   cacheKey?(dataItem, ctx) — добавка к ключу кеша грида (например, свёрнутость строки у composition).
//   IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T9): layersOf может вернуть sizeValue — размер круга (cellRing_build opts.sizeValue; грид передаёт res.sizeValue), value — для over-100;
//   tipOf получает ctx.fmt (формат числа ячейки); emptyNoteOf?(ctx) → строка — подсказка ячейки без круга (delta_30d: «снимков ещё нет»), ctx.stats —
//   doc.cell_views_stats (и cell_views_stats_deferred) ответа, заполняет грид.
// Рендер круга — src/utils/cellRing.js (cellRing_build). Чистые функции — tests/unit/cellViews.test.mjs.
// Выключатели (по умолчанию ВКЛ): fe.ux.cellViews — все режимы; fe.ux.cellView.<режим> — один режим (ВЫКЛ — ячейки показывают числа)
import { t as tI18n } from '@/i18n'
import { cellPie_bindingOf } from '@/utils/cellPie'
import { heatmap_share_pct } from '@/utils/heatmapMatrix'
import { hmTip_esc } from '@/utils/heatmapTip'
import statusZones from './statusZones'
import composition from './composition'
import stockImpact from './stockImpact'
import deltaPrevRun from './deltaPrevRun'
import delta30d from './delta30d'
import statusDot from './statusDot'   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: статуси-крапка, зони запасів, виконання планів — T12)
import signals from './signals'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p198 вид «Сигнали» — проблемні сигнали шарами кола, фон лише від lead time / циклу поповнення / зон запасу)
import plans from './plans'   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: статуси-крапка, зони запасів, виконання планів — T12)

export const CELL_VIEWS_FLAG = 'fe.ux.cellViews'
export const CELL_VIEW_NUMBERS = 'numbers'
export const CELL_VIEW_ALIASES = { status_pie: 'status_zones' }
export const CELL_VIEW_ORDER = ['numbers', 'signals', 'composition', 'status_zones', 'status_dot', 'stock_impact', 'delta_prev_run', 'delta_30d', 'plans']   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: статуси-крапка, зони запасів, виконання планів — T12): + status_dot, plans   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p198 вид «Сигнали» — проблемні сигнали шарами кола, фон лише від lead time / циклу поповнення / зон запасу): + signals первым после numbers

const numbers = { key: CELL_VIEW_NUMBERS, title: 'Numbers', satellites: [], needsData: false, layersOf() { return null }, tipOf() { return null } }
const REGISTRY = Object.create(null)
for (const e of [numbers, signals, composition, statusZones, statusDot, stockImpact, deltaPrevRun, delta30d, plans]) REGISTRY[e.key] = e   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p198 вид «Сигнали» — проблемні сигнали шарами кола, фон лише від lead time / циклу поповнення / зон запасу); // IE 2026 11 01 / ODOO-350449 (заказ Игоря: статуси-крапка, зони запасів, виконання планів — T12)

const str = (v) => (v === null || v === undefined ? '' : String(v)).trim()
const num = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0 }

// имя вида → ключ регистра (алиас status_pie → status_zones); пусто — ''
export function cellView_key(view) {
    const k = str(view)
    return CELL_VIEW_ALIASES[k] || k
}
export function cellView_get(view) {
    return REGISTRY[cellView_key(view)] || null
}
export function cellView_modes() {
    return CELL_VIEW_ORDER.slice()
}
// регистрация / замена режима (реализация T3 / T9, тесты); без key или layersOf — false
export function cellView_register(entry) {
    if (!entry || !str(entry.key) || typeof entry.layersOf !== 'function') return false
    REGISTRY[str(entry.key)] = entry
    return true
}
export function cellView_modeFlag(view) {
    return `fe.ux.cellView.${cellView_key(view)}`
}
// общий флаг и флаг режима (нет читателя / ошибка — ВКЛ); numbers — всегда ВКЛ
export function cellView_flagOn(setting, view) {
    const rd = (k) => { try { return typeof setting === 'function' ? setting(k, true) !== false : true } catch (e) { return true } }
    if (!rd(CELL_VIEWS_FLAG)) return false
    const k = cellView_key(view)
    if (!k || k === CELL_VIEW_NUMBERS) return true
    return rd(cellView_modeFlag(k))
}
// прежнее состояние { status_pie: true, … } (WIDGET._cellViews) → ключ активного вида в порядке CELL_VIEW_ORDER (алиасы учтены) | ''
export function cellView_fromLegacy(views) {
    if (!views || typeof views !== 'object') return ''
    const on = new Set(Object.keys(views).filter(k => views[k]).map(cellView_key))
    for (const k of CELL_VIEW_ORDER) if (k !== CELL_VIEW_NUMBERS && on.has(k)) return k
    for (const k of on) if (REGISTRY[k] && k !== CELL_VIEW_NUMBERS) return k
    return ''
}
// активный вид виджета: WIDGET._cellView (строка) — главный признак, иначе прежний WIDGET._cellViews; «numbers» / неизвестный — ''
export function cellView_activeOf(WIDGET) {
    if (!WIDGET) return ''
    const k = typeof WIDGET._cellView === 'string' ? cellView_key(WIDGET._cellView) : cellView_fromLegacy(WIDGET._cellViews)
    return (k && k !== CELL_VIEW_NUMBERS && REGISTRY[k]) ? k : ''
}

// слои ячейки активного вида: разбор привязки колонки `YYYY-MM-DD.<мера>`, ctx дополняется date / measure / cell / value.
// → { layers (≥ 1 с положительным значением), value, signals, satellite?, view } | null
export function cellView_layersOf(view, dataItem, binding, ctx = {}) {
    const e = cellView_get(view)
    if (!e || e.key === CELL_VIEW_NUMBERS || !dataItem || typeof dataItem !== 'object') return null
    const b = cellPie_bindingOf(binding)
    if (!b) return null
    const cell = dataItem[b.date]
    const value = (cell && typeof cell === 'object') ? cell[b.measure] : undefined
    const c = { t: tI18n, ...ctx, binding, date: b.date, measure: b.measure, cell: (cell && typeof cell === 'object') ? cell : null, value }
    let res
    try { res = e.layersOf(dataItem, binding, c) } catch (err) { res = null }
    if (!res || !Array.isArray(res.layers) || !res.layers.some(l => num(l && l.value) > 0)) return null
    const v = (res.value !== undefined && res.value !== null && res.value !== '' && Number.isFinite(Number(res.value))) ? Number(res.value) : undefined
    const sv = (res.sizeValue !== undefined && res.sizeValue !== null && res.sizeValue !== '' && Number.isFinite(Number(res.sizeValue))) ? Number(res.sizeValue) : undefined   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T9)
    return { ...res, value: v, sizeValue: sv, signals: Array.isArray(res.signals) ? res.signals : [], view: e.key }
}

// подсказка ячейки, у которой круга нет, но режиму есть что сказать (delta_30d: снимков ещё нет) → строка | ''. IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T9)
export function cellView_emptyNote(view, ctx = {}) {
    const e = cellView_get(view)
    if (!e || typeof e.emptyNoteOf !== 'function') return ''
    try { return str(e.emptyNoteOf({ t: tI18n, ...ctx })) } catch (err) { return '' }
}

// IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T9b)
// статистика видов ответа для ctx.stats режимов: [doc.cell_views_stats (основной ответ), doc.cell_views_stats_deferred (отложенный, T2)] — только объекты
export function cellView_statsOf(doc) {
    if (!doc || typeof doc !== 'object') return []
    return [doc.cell_views_stats, doc.cell_views_stats_deferred].filter(s => !!s && typeof s === 'object' && !Array.isArray(s))
}
// IE 2026 11 01 / ODOO-350449 (заказ Игоря: p149 fix2-fe — цвета статусов из палитры бэка stats.palette)
// палитра статусов бэка для ctx.palette: stats.palette основного ответа (doc.cell_views_stats), затем последняя палитра отложенных ответов (doc.cell_views_palette) → объект | null
export function cellView_paletteOf(doc) {
    if (!doc || typeof doc !== 'object') return null
    const ok = (p) => !!p && typeof p === 'object' && !Array.isArray(p) && Object.keys(p).length > 0
    const main = doc.cell_views_stats && typeof doc.cell_views_stats === 'object' ? doc.cell_views_stats.palette : null
    const late = doc.cell_views_palette
    if (ok(main) && ok(late)) return { ...main, ...late }
    return ok(late) ? late : ok(main) ? main : null
}
// подсказка ячейки-даты без круга: вид ждёт данных бэка (ready === false) — «Computing data for the view …»; иначе — emptyNoteOf режима
// (delta_30d: «Snapshots not taken yet»). opts: { ready, stats, t } → строка | ''
export function cellView_emptyNoteAt(view, opts = {}) {
    const e = cellView_get(view)
    if (!e || e.key === CELL_VIEW_NUMBERS) return ''
    const t = typeof opts.t === 'function' ? opts.t : tI18n
    if (e.needsData && opts.ready === false) return str(t('Computing data for the view {view}…', { view: t(e.title) }))
    return cellView_emptyNote(e.key, { t, stats: opts.stats })
}
// html подсказки без круга (стиль hm-tip, как cellView_tipHtml): заголовок ячейки и примечание; пустое примечание — ''
export function cellView_emptyTipHtml(note, opts = {}) {
    const n = str(note)
    if (!n) return ''
    const head = str(opts.head)
    return `<div class="hm-tip hm-tip-g cell-ring-tip">`
        + (head ? `<div class="hm-tip-head"><div class="hm-tip-title">${hmTip_esc(head)}</div></div>` : '')
        + `<div class="hm-tip-sub">${hmTip_esc(n)}</div></div>`
}

// Alt-подсказка круга — стиль hm-tip (как прежний пирог cellPie_tipHtml): заголовок, «Cell value», раздел режима (строки со значениями и долями), примечания.
// opts: { t, fmt, head, value (значение ячейки), ctx }
export function cellView_tipHtml(view, res, opts = {}) {
    const e = cellView_get(view)
    if (!e || !res) return ''
    const t = typeof opts.t === 'function' ? opts.t : tI18n
    const fmt = typeof opts.fmt === 'function' ? opts.fmt : (v) => String(v ?? '')
    let tip = null
    try { tip = typeof e.tipOf === 'function' ? e.tipOf(res, { t, fmt, ...(opts.ctx || {}) }) : null } catch (err) { tip = null }   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: режими відображення комірок p149, T9): + fmt
    tip = tip || {}
    const rows = Array.isArray(tip.rows) ? tip.rows : (Array.isArray(res.layers) ? res.layers.filter(l => num(l && l.value) > 0) : [])
    const pos = rows.reduce((s, r) => s + Math.max(0, num(r && r.value)), 0)
    const html = rows.map(r => {
        if (r && r.plain) return `<span class="hm-tip-k"><i class="hm-tip-sw" style="background:${hmTip_esc(r.color || '#9e9e9e')}"></i><span class="hm-tip-kt">${hmTip_esc(r.title ?? r.key ?? '')}</span></span><span class="hm-tip-v"></span>`   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p198 вид «Сигнали» — проблемні сигнали шарами кола, фон лише від lead time / циклу поповнення / зон запасу): строка без значения и доли (сигналы)
        const share = r.share !== undefined ? r.share : (pos > 0 ? Math.max(0, num(r.value)) / pos : 0)
        return `<span class="hm-tip-k"><i class="hm-tip-sw" style="background:${hmTip_esc(r.color || '#9e9e9e')}"></i><span class="hm-tip-kt">${hmTip_esc(r.title ?? r.key ?? '')}</span></span>`
            + `<span class="hm-tip-v">${hmTip_esc(fmt(r.value))} <span class="hm-tip-vs">${hmTip_esc(heatmap_share_pct(share))}</span></span>`
    }).join('')
    const notes = (Array.isArray(tip.note) ? tip.note : (tip.note ? [tip.note] : [])).map(n => `<div class="hm-tip-sub">${hmTip_esc(n)}</div>`).join('')
    const head = str(opts.head)
    const cv = opts.value !== undefined && opts.value !== null && opts.value !== '' ? opts.value : res.value
    const cap = str(tip.caption) || t(e.title)
    return `<div class="hm-tip hm-tip-g cell-pie-tip cell-ring-tip">`
        + `<div class="hm-tip-head">${head ? `<div class="hm-tip-title">${hmTip_esc(head)}</div>` : ''}<div class="hm-tip-sub">${hmTip_esc(t('Cell value'))}: ${hmTip_esc(fmt(cv))}</div>`
        + (num(opts.rowMax) > 0 ? `<div class="hm-tip-sub">${hmTip_esc(t('Row maximum: {n}', { n: fmt(opts.rowMax) }))}</div>` : '') + `</div>`   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p190 — розмір кола від максимуму рядка, 60…100 %)
        + (html ? `<div class="hm-tip-sec"><div class="hm-tip-cap">${hmTip_esc(cap)}</div>${html}</div>` : '')
        + notes + `</div>`
}
